import Api from "./Api";
import AuthApi from "./AuthApi";
import MitgliederApi from "./MitgliederApi";
import StatuserweiterungApi from "./StatuserweiterungApi";
import ProbenplanApi from "./ProbenplanApi";
import ProbentypApi from "./ProbentypApi";
import BenutzerverwaltungApi from "./BenutzerverwaltungApi";
import WerkeApi from "./WerkeApi";
import StatusApi from "./StatusApi";
import FileApi from "./FileApi";
import ProbenStammdatenApi from "./ProbenStammdatenApi";
import AnwesenheitsverwaltungApi from "./AnwesenheitsverwaltungApi";
import MigrationApi from "./MigrationApi";
import WordpressApi from "./WordpressApi";
import ChangelogApi from "./ChangelogApi";
import AbrechnungGastApi from "./AbrechnungGastApi";
import WidgetApi from "./WidgetApi";
import PDFTemplateApi from "./PDFTemplateApi";
import HowtoApi from "./HowtoApi";
import MaintenanceApi from "./MaintenanceApi";
import NotenverwaltungApi from "./NotenverwaltungApi";
import NotentransferSVApi from "./NotentransferSVApi";
import NotentransferMitgliederApi from "./NotentransferMitgliederApi";
import NotenTransactionsApi from "./NotenTransactionsApi";
import SingPauseApi from "./SingPauseApi";
import FiBuBuchungskontoApi from "./FiBuBuchungskontoApi";
import FiBuFinanzkontoApi from "./FiBuFinanzkontoApi";
import FiBuCategoryApi from "./FiBuCategoryApi";
import FiBuGroupApi from "./FiBuGroupApi";
import FiBuVerwendungszweckApi from "./FiBuVerwendungszweckApi";
import FiBuStatusStammdatenApi from "./FiBuStatusStammdatenApi";
import FiBuBuchungApi from "./FiBuBuchungApi";
import FiBuOffenePosten from "./FiBuOffenePosten";
import FiBuSuSaApi from "./FiBuSuSaApi";
import FiBuSpendenquittungApi from "./FiBuSpendenquittungApi";
import FiBuJahresabschlussApi from "./FiBuJahresabschlussApi";
import FiBuBuchungsstapelApi from "@/api/FiBuBuchungsstapelApi";
import FiBuBuchungsvorlageApi from "@/api/FiBuBuchungsvorlageApi";
import FiBuMitgliedsbeitraegeApi from "@/api/FiBuMitgliedsbeitrageApi";
import FiBuKontenblaetterApi from "@/api/FiBuKontenblaetterApi";
import FiBuZuschusskontoApi from "@/api/FiBuZuschusskontoApi";
import FiBuRuecklagenkontoApi from "@/api/FiBuRuecklagenkontoApi";

const repositories = {
    api: Api,
    auth: AuthApi,
    mitglieder: MitgliederApi,
    statuserweiterung: StatuserweiterungApi,
    probenplan: ProbenplanApi,
    probentyp: ProbentypApi,
    benutzerverwaltung: BenutzerverwaltungApi,
    werke: WerkeApi,
    status: StatusApi,
    files: FileApi,
    proben_stammdaten: ProbenStammdatenApi,
    anwesenheitsverwaltung: AnwesenheitsverwaltungApi,
    migration: MigrationApi,
    wordpress: WordpressApi,
    changelog: ChangelogApi,
    abrechnung_gast: AbrechnungGastApi,
    widgets: WidgetApi,
    templates: PDFTemplateApi,
    howto: HowtoApi,
    maintenance: MaintenanceApi,
    notenverwaltung: NotenverwaltungApi,
    notentransferSV: NotentransferSVApi,
    notentransferMitglieder: NotentransferMitgliederApi,
    notentransactions: NotenTransactionsApi,
    singpause: SingPauseApi,
    fibuBuchungskonto: FiBuBuchungskontoApi,
    fibuFinanzkonto: FiBuFinanzkontoApi,
    fibuZuschusskonto: FiBuZuschusskontoApi,
    fibuRuecklagenkonto: FiBuRuecklagenkontoApi,
    fibuCategory: FiBuCategoryApi,
    fibuGroup: FiBuGroupApi,
    fibuVerwendungszweck: FiBuVerwendungszweckApi,
    fibuStatusStamm: FiBuStatusStammdatenApi,
    fibuBuchung: FiBuBuchungApi,
    fibuOffenePosten: FiBuOffenePosten,
    fibuSusa: FiBuSuSaApi,
    fibuSpendenquittung: FiBuSpendenquittungApi,
    fibuJahresabschluss: FiBuJahresabschlussApi,
    fibuBuchungsstapel: FiBuBuchungsstapelApi,
    fibuBuchungsvorlage: FiBuBuchungsvorlageApi,
    fiBuMitgliedsbeitraegeApi: FiBuMitgliedsbeitraegeApi,
    fibuKontenblaetterApi: FiBuKontenblaetterApi
};

export const ApiFactory = {
    get: name => repositories[name]
};
